<template>
  <div>
    <headerNav title="大货明细" />
    <van-calendar v-model="show" :min-date="minDate" type="range" @confirm="onConfirm"/>
    <van-sticky>
      <van-cell title="选择订单时间" :value="date" @click="show = true" />
    </van-sticky>
    <div>
        <van-tabs v-model="tabCurrentIndex" @change="tabchange" sticky offset-top="44">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-tab :title="navitem.text" v-for="(navitem,navindex) in navList" :key="navindex">
                <van-list
                      v-model="navitem.loaded"
                      :finished="navitem.loadingType=='nomore'?true:false"
                      :finished-text="navitem.loadingType=='nomore'?'没有更多了':'下拉加载更多'"
                      @load="loadData"
                  >
                    <div v-for="(item,index) in navitem.List" class="mian-list"  @click="detail(item)" :key="index">
                            <div class="mian-list-info">
                                <div class="mian-list-info-data">
                                  <span>金额:{{item.costMoney}}</span>
                                  <span>{{item.money}}</span> 
                                   <van-tag type="primary" class="mian-list-info-right-tag" v-if="item.balanceType==1" size="medium">{{item.balanceTypeName}}</van-tag>
                                   <van-tag type="danger" class="mian-list-info-right-tag" v-if="item.balanceType==7" size="medium">{{item.balanceTypeName}}</van-tag>
                                   <van-tag type="success" class="mian-list-info-right-tag" v-if="item.balanceType==11" size="medium">{{item.balanceTypeName}}</van-tag>
                                   <van-tag type="success" class="mian-list-info-right-tag" v-if="item.balanceType==12" size="medium">{{item.balanceTypeName}}</van-tag>
                                </div>
                                <div class="mian-list-info-data">
                                  <span>备注:</span>
                                  <span>{{item.comment}}</span>
                                </div>
                                <div class="mian-list-info-data-last">
                                    {{item.creationTime}}
                                </div>
                          </div>
                           
                          <!-- <div class="mian-list-mark" v-if="item.comment">
                              <div>备注:{{item.comment}}</div>
                          </div> -->
                    </div>
                </van-list>
              </van-tab>
          </van-pull-refresh>
      </van-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      date: "",
      sticky:true,
      popshow:false,
      show: false,
       minDate: new Date(2020, 0, 1),
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      fileList:[],
      pageParams: {
        maxResultCount: 8,
        skipCount: 0,
      },
      totalCount: 0,
      tabCurrentIndex:0,
      navList: [{
          state: 0,
          text: '全部',
          loadingType: 'more',
          loaded:false,
          getparams: {
              productType:1,
              sorting: "",
              maxResultCount: 10,
              skipCount: 0
          },
          List: []
          },
          {
            state: 1,
            text: '订单支付',
            loadingType: 'more',
            loaded:false,
            getparams: {
                productType:1,
                balanceType:1,
                sorting: "",
                maxResultCount: 10,
                skipCount: 0
            },
            List: []
          },
           {
              state: 3,
              text: '订单退款',
              loadingType: 'more',
              loaded:false,
              getparams: {
                  productType:1,
                  balanceType:7,
                  sorting: "",
                  maxResultCount: 10,
                  skipCount: 0
              },
              List: []
          },
           {
              state: 3,
              text: '充值',
              loadingType: 'more',
              loaded:false,
              getparams: {
                  productType:1,
                  balanceType:11,
                  sorting: "",
                  maxResultCount: 10,
                  skipCount: 0
              },
              List: []
          },
          //  {
          //     state: 4,
          //     text: '划拨',
          //     loadingType: 'more',
          //     loaded:false,
          //     getparams: {
          //         productType:1,
          //         balanceType:12,
          //         sorting: "",
          //         maxResultCount: 10,
          //         skipCount: 0
          //     },
          //     List: []
          // }
      ],
      starttime:undefined,
      endtime:undefined,
      iptvalue:undefined,
    };
  },
  created(){
     
  },
  methods: {
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    onclose()
    {
      this.sticky=true;
    },
    onConfirm(date) {
      this.sticky=false;
      const [start, end] = date;
      this.show = false;
      this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;

      this.starttime=start;
      this.endtime=end;
      this.navList.forEach(x=>{
          x.loadingType="refresh";
      });
      this.loadData();
      //将数组重置 并重新执行查询

      //startTime
      //endTime
    },
    onSearch(val){
        //将数组重置 并重新执行查询
      console.log(val);
      this.iptvalue=val;
      this.navList.forEach(x=>{
          x.loadingType="refresh";
      });
      this.loadData();
    },
    tabchange()
    {
        this.loadData('tabChange');
    },
    onRefresh()
    {
        this.loadData('refresh');
    },
    loadData(source) {
                 
        let index = this.tabCurrentIndex;
        let navItem = this.navList[index];
        // let state = navItem.state;
        
        if (source === 'tabChange' && navItem.loaded === true) {
            //tab切换只有第一次需要加载数据
            return;
        }

        if (navItem.loadingType === 'loading' || navItem.loadingType === 'nomore') {
          //防止重复加载
          if(source!='refresh')
          {
            return;
          }
        }
        
        if (source == 'refresh'||navItem.loadingType=='refresh') {
        this.navList[index].List = [];
        this.navList[index].getparams.skipCount = 0;
        this.navList[index].getparams.startTime=this.starttime;
        this.navList[index].getparams.endtime=this.endtime;
        this.navList[index].getparams.tid=this.iptvalue;
        }

        navItem.loadingType = 'loading';
        var params = navItem.getparams;
		//加载数据
        this.ajax.post('/api/services/app/PhoneUser/QueryCostLog', params).then(x => {
            this.navList[index].getparams.skipCount += this.navList[index].getparams.maxResultCount;
            let totalcount = x.result.totalCount;
            this.navList[index].List = this.navList[index].List.concat(x.result.items);
          //console.log(this.navList);
          // item = Object.assign(item, this.orderStateExp(item.state));
              this.navList[index].loadingType = totalcount > (this.navList[index].getparams.skipCount) ? 'more' :'nomore';
          }).finally(()=>
          {
              this.$set(this.navList[index], 'loaded', false);
              this.refreshing=false;
          });

    },
    // onLoad() {
    //   if (this.refreshing) {
    //     this.list = [];
    //     this.refreshing = false;
    //     this.pageParams.skipCount = 0;
    //   }
    //   this.ajax
    //     .post(
    //       "/api/services/app/PhoneUser/QuerySubRechargeRecordPages",
    //       this.pageParams
    //     )
    //     .then((x) => {
    //       const items = x.result.items;
    //       this.list.push(...x.result.items);
    //       this.pageParams.skipCount += this.pageParams.maxResultCount;
    //       this.totalCount = x.result.totalCount;
    //     })
    //     .finally(() => {
    //       this.loading = false;

    //       if (this.pageParams.skipCount >= this.totalCount) {
    //         this.finished = true;
    //       }
    //     });
    // },
    // onRefresh() {
    //   // 清空列表数据
    //   this.finished = false;

    //   // 重新加载数据
    //   // 将 loading 设置为 true，表示处于加载状态
    //   this.loading = true;
    //   this.onLoad();
    // },
  },
};
</script>
<style lang="scss" scoped>
.mian-list{
  background-color: #fff;
  margin-top: 10px;
  font-size: 12px;
  border-radius: 8px;
  margin: 10px;
  padding: 10px;
  box-shadow: 1px 1px 4px #c3c3c3;
  word-break: break-all;
  line-height: 20px;
}
.mian-list-info{
  padding: 5px 0 5px 0px;
  font-size: 14px;
  position: relative;
  word-break: break-all;
}
.mian-list-info-right{
  position: absolute;
  right: 0;
  width: 90px;
  text-align: right;
}
.mian-list-info-right-tag{
  position: absolute;
  right: 0;
}
.mian-list-mark{
  border-top: 1px solid #e2e2e2;
  padding-top: 10px;
  font-size: 18px;
}
.mian-list-btns{
  margin-top: 20px;
  text-align: center;
}
.mian-list-btns button{
    margin-right: 10px;
    padding: 8px 20px;
    height: auto;
    border-radius: 34px;
    border: 0;
}
.mian-list-pic{
  position: absolute;
  top: 50%;
  left:0;
  width: 100px;
  height: 100px;
  transform: translate(0,-50%);
}
.mian-list-pic img{
  width: 100%;
  height: 100%;
}
.info{
    position: relative;
    background-color: #fff;
    border-radius: 8px;
    margin: 20px 10px 10px 10px;
    font-size: 12px;
    width: 250px;
}
.mz-proof-btns{
  margin-bottom: 10px;
  text-align: center;
}
.mz-proof-btns button{
  margin-right: 10px;
  padding: 8px 20px;
  height: auto;
  border-radius: 34px;
  border: 0;
}
.mian-list-info-data-last{
  text-align: right;
}
</style>
<style lang="scss" scoped>
.van-uploader__wrapper{
    width: 100%;
    display: block;
  }
  
  .van-uploader__upload{
    width: 100%;
  }
  .van-uploader{
    display: block;
  }
  .van-uploader__preview-image{
    width: 100%;
    height: 80px;
  }
  </style>